import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import 'react-phone-input-2/lib/material.css'
import PlayIcon from '../assets/imgs/play-icon.svg'
import PauseIcon from '../assets/imgs/pause-icon.svg'
import PlayCircleIcon from '@mui/icons-material/PlayCircle'
import PauseCircleIcon from '@mui/icons-material/PauseCircle'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
}

const OnboardingVideoModal = ({
  handleOnboardingVideoModal,
  modalOpen = false,
}) => {
  const [verifyPhoneNumber, setVerifyPhoneNumber] = React.useState(false)
  const [isPlaying, setIsPlaying] = React.useState(false)
  const hanleIsPlaying = () => {
    setIsPlaying(!isPlaying)
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={() => handleOnboardingVideoModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h3 className="fs-24 mb-4 fw-bold">Onboarding Video</h3>
          <div className="video-player">
            {isPlaying === true ? (
              <PauseCircleIcon
                onClick={hanleIsPlaying}
                className="pause-icon pointer"
                sx={{ color: '#fff', fontSize: '40px' }}
              />
            ) : (
              // <img
              //   onClick={hanleIsPlaying}
              //   src={PlayIcon}
              //   alt=""
              //   className="play-icon pointer"
              // />
              <PlayCircleIcon
                onClick={hanleIsPlaying}
                sx={{ color: '#fff', fontSize: '40px' }}
                className="play-icon pointer"
              />
              // <img
              //   src={PauseIcon}
              //   onClick={hanleIsPlaying}
              //   alt=""
              //   className="pause-icon pointer"
              // />
            )}
          </div>
          <Button
            disableElevation
            id="btn-primary-no-shadow"
            variant="contained"
            className="pointer mt-5"
            fullWidth={true}
            onClick={() => setVerifyPhoneNumber(true)}
          >
            Continue
          </Button>
        </Box>
      </Modal>
    </div>
  )
}

export default OnboardingVideoModal
